import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollToService {
  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: any
  ) {}

  scrollToTop(duration, scrollToBlock, fixedElemHeight?: number) {
    const element = this.document.querySelector(scrollToBlock);
    if (!element || !isPlatformBrowser(this.platformId)) {
      return;
    }

    let scrollEndElemTop = element.getBoundingClientRect().top;

    if (duration === 0) {
      window.scroll(0, scrollEndElemTop);
    } else {
      const easeInCubic = (t) => {
        return t * t;
      };
      const scrollToElem = (startTime, currentTime, duration, scrollEndElemTop, startScrollOffset) => {
        const runtime = currentTime - startTime;
        const progress = Math.min(runtime / duration, 1);
        const ease = easeInCubic(progress);

        window.scroll(0, startScrollOffset + scrollEndElemTop * ease);
        if (runtime < duration) {
          requestAnimationFrame((timestamp) => {
            const currentTime = timestamp || new Date().getTime();
            scrollToElem(startTime, currentTime, duration, scrollEndElemTop, startScrollOffset);
          });
        }
      };
      requestAnimationFrame((timestamp) => {
        const stamp = timestamp || new Date().getTime();
        const start = stamp;
        const startScrollOffset = window.pageYOffset;

        if (scrollEndElemTop != 0 && fixedElemHeight) {
          scrollEndElemTop = scrollEndElemTop - (fixedElemHeight || 0);
        }
        scrollToElem(start, stamp, duration, scrollEndElemTop, startScrollOffset);
      });
    }
  }

  scrollToPageTop(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  scrollToError(errorClassName: string): void {
    const el = document.getElementsByClassName(errorClassName);

    if (el?.length) {
      setTimeout(() => {
        const headerOffset = 200;
        const elementPosition = el[0].getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 0);
    }
  }
}
